import { CarBodiesType, MarkType, ModelType, ModificationType, YearCurrentType } from '@app/entities/Auto';
import { Part, PartBrand, PartProduct, ProductSpecifications } from '@app/entities/Product';
import { FilterElementsSchema, FormBlock } from './filterElementsSchema';

export enum FilterTemplates {
  Tyres = 'tyres-template',
  TruckTyres = 'truck-tyres-template',
  Disks = 'disks-template',
  TruckDisks = 'truck-disks-template',
  Akb = 'accumulators-template',
  Oils = 'oils-template',
  TyresAuto = 'tyres-auto',
  DisksAuto = 'disks-auto',
  AkbAuto = 'akb-auto',
  TyresModels = 'tyres-models-template',
  DisksModels = 'disks-models-template',
  TruckTyresModels = 'truck-tyres-models-template',
}

export const connectionTemplateTab = [FilterTemplates.TyresAuto, FilterTemplates.DisksAuto, FilterTemplates.AkbAuto];

export const isModelTemplate = (template: FilterTemplates) =>
  [FilterTemplates.TyresModels, FilterTemplates.DisksModels, FilterTemplates.TruckTyresModels].includes(template);

export const ConnectTemplateModelToProduct = {
  [FilterTemplates.TyresModels]: FilterTemplates.Tyres,
  [FilterTemplates.DisksModels]: FilterTemplates.Disks,
  [FilterTemplates.TruckTyresModels]: FilterTemplates.TruckTyres,
};

export const PartConnectionTemplate = {
  [FilterTemplates.Tyres]: PartProduct.Tyres,
  [FilterTemplates.TyresAuto]: PartProduct.Tyres,
  [FilterTemplates.TyresModels]: PartBrand.Tyres,
  [FilterTemplates.TruckTyres]: PartProduct.TruckTires,
  [FilterTemplates.TruckTyresModels]: PartBrand.TruckTires,
  [FilterTemplates.Disks]: PartProduct.Disks,
  [FilterTemplates.DisksAuto]: PartProduct.Disks,
  [FilterTemplates.DisksModels]: PartBrand.Disks,
  [FilterTemplates.TruckDisks]: PartProduct.Disks,
  [FilterTemplates.Akb]: PartProduct.Batteries,
  [FilterTemplates.AkbAuto]: PartProduct.Batteries,
  [FilterTemplates.Oils]: PartProduct.Oils,
};

export const CountProductPage = (template: FilterTemplates): number => {
  switch (template) {
    case FilterTemplates.TyresAuto:
    case FilterTemplates.DisksAuto:
    case FilterTemplates.AkbAuto:
      return 25;
    default:
      return 24;
  }
};

export const PageUrlConnectionTemplate = {
  [FilterTemplates.Tyres]: 'catalog/filter/tyres/',
  [FilterTemplates.TyresModels]: 'catalog/filter/tyres/',
  [FilterTemplates.TruckTyres]: 'catalog/filter/trucktyres/',
  [FilterTemplates.TruckTyresModels]: 'catalog/filter/trucktyres/',
  [FilterTemplates.Disks]: 'catalog/filter/discs/',
  [FilterTemplates.DisksModels]: 'catalog/filter/discs/',
  [FilterTemplates.TruckDisks]: 'catalog/filter/discs/',
  [FilterTemplates.Akb]: 'catalog/filter/accumulators/',
  [FilterTemplates.Oils]: 'catalog/filter/oils/',
  [FilterTemplates.TyresAuto]: 'auto/',
  [FilterTemplates.DisksAuto]: 'auto/disks/',
  [FilterTemplates.AkbAuto]: 'auto/accumulators/',
};

export const PageDefaultTitleTemplate = {
  [FilterTemplates.Tyres]: 'Шины',
  [FilterTemplates.TyresModels]: 'Шины',
  [FilterTemplates.TruckTyres]: 'Грузовые шины',
  [FilterTemplates.TruckTyresModels]: 'Грузовые шины',
  [FilterTemplates.Disks]: 'Диски',
  [FilterTemplates.DisksModels]: 'Диски',
  [FilterTemplates.TruckDisks]: 'Грузовые диски',
  [FilterTemplates.Akb]: 'Аккумуляторы',
  [FilterTemplates.Oils]: 'Масла',
  [FilterTemplates.TyresAuto]: 'Подбор шин по авто',
  [FilterTemplates.DisksAuto]: 'Подбор дисков по авто',
  [FilterTemplates.AkbAuto]: 'Подбор АКБ',
};

export enum fieldsAuto {
  Mark = 'mark',
  Model = 'model',
  Year = 'year',
  Modification = 'modification',
  CarBody = 'carBody',
}

type CurrentValueAuto = {
  mark: MarkType;
  model: ModelType;
  year: YearCurrentType;
  modification: ModificationType;
  carBody?: CarBodiesType;
};

export type Brands = {
  title: string;
  value: string;
  sort: number;
  checked: boolean;
};

export type CurrentCheckbox = {
  name: string;
  value: boolean;
};

export type CurrentSelect = {
  name: string;
  value: any;
};

export enum PriceConst {
  minPrice = 0,
  maxPrice = 143480,
}

export type ParamsType = {
  [Key: string]: any;
};

export type CheckboxType = {
  name: string;
  value: string;
};

export interface FilterSchema {
  template: FilterTemplates;
  strParams: string;
  shortStrParams: string;
  autoSelects: CurrentValueAuto;
  minPrice: number;
  maxPrice: number;
  sparky?: number[];
  protectorMinPrice: number;
  protectorMaxPrice: number;
  params: ParamsType;
  schemaFilter: FilterElementsSchema;
  schemaParamsBlock: FormBlock;
  currentPage?: number;
  isInitial: boolean;
  isLoadingSchemaFilter: boolean;
  isSeoUrl?: boolean;
  skipProductDataFetch: boolean;
}

export enum General {
  Page = 'page',
  GetShop = 'get_shop',
  ActionType = 'action_type',
  GetAction = 'get_action',
  Sort = 'sort',
  Order = 'order',
  Xl = 'xl',
  OffRoad = 'off_road',
  LowProfile = 'low_profile',
  Replica = 'replica',
  StrictMode = 'strict_mode',
}

export const mapPriceCategory = {
  [FilterTemplates.Tyres]: {
    minPrice: ProductSpecifications.TyresMinPrice,
    maxPrice: ProductSpecifications.TyresMaxPrice,
  },

  [FilterTemplates.Disks]: {
    minPrice: ProductSpecifications.DiscsMinPrice,
    maxPrice: ProductSpecifications.DiscsMaxPrice,
  },
  [FilterTemplates.Akb]: {
    minPrice: ProductSpecifications.AkbMinPrice,
    maxPrice: ProductSpecifications.AkbMaxPrice,
  },
  [FilterTemplates.TruckTyres]: {
    minPrice: ProductSpecifications.TruckTyresMinPrice,
    maxPrice: ProductSpecifications.TruckTyresMaxPrice,
  },
  [FilterTemplates.Oils]: {
    minPrice: ProductSpecifications.OilMinPrice,
    maxPrice: ProductSpecifications.OilMaxPrice,
  },
  [FilterTemplates.TyresModels]: {
    minPrice: ProductSpecifications.TyresMinPrice,
    maxPrice: ProductSpecifications.TyresMaxPrice,
  },
  [FilterTemplates.DisksModels]: {
    minPrice: ProductSpecifications.TyresMinPrice,
    maxPrice: ProductSpecifications.TyresMaxPrice,
  },
  [FilterTemplates.TruckTyresModels]: {
    minPrice: ProductSpecifications.TruckTyresMinPrice,
    maxPrice: ProductSpecifications.TruckTyresMaxPrice,
  },
};
